import MajorEventsCardContainer from './major-events-card-container'

export default MajorEventsCardContainer
